// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Page_pageHeader_2tRBO"};